"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = arrayMerge;

var _lodash = require("lodash");

function arrayMerge(objValue, srcValue) {
  if ((0, _lodash.isArray)(objValue)) {
    return objValue.concat(srcValue);
  }

  if (typeof objValue !== 'undefined') {
    var wrapped = [objValue];
    return wrapped.concat(srcValue);
  }

  return undefined;
}